import { Pipe, PipeTransform } from '@angular/core';
import {formatNumber} from '@angular/common';

@Pipe({
    name: 'spreaderMass',
})
export class SpreaderMassPipe implements PipeTransform {

  transform(value: any, useMetricSystem?: boolean, showUnits: boolean = true): any {
    // mass param is in kg/m, recalc to lbs/mi or kg/km
    if (typeof(value) === 'number') {
      if (useMetricSystem) { // use metric system
        return `${formatNumber(value * 1000, 'en-US', '0.1-2')}${showUnits ? ' kg/km' : ''}`;
      } else {
        return `${formatNumber(value * 3548, 'en-US', '0.1-2')}${showUnits ? ' lbs/mi' : ''}`;
      }
    } else {
      return 'N/A';
    }
  }
}
